/* eslint-disable jira/filename-case */
export const SERVICE_DESK = 'jira-servicedesk' as const;
export const CUSTOMER_SERVICE = 'jira-customer-service' as const;
export const SOFTWARE = 'jira-software' as const;
export const PRODUCT_DISCOVERY = 'jira-product-discovery' as const;
export const CORE = 'jira-core' as const;
export const CONFLUENCE = 'confluence' as const;
export const OPSGENIE = 'opsgenie' as const;
export const ASSETS = 'assets' as const;
export const COMPASS = 'compass' as const;

export type ApplicationKey =
	| typeof SERVICE_DESK
	| typeof CUSTOMER_SERVICE
	| typeof SOFTWARE
	| typeof PRODUCT_DISCOVERY
	| typeof CORE
	| typeof ASSETS
	| typeof COMPASS;
